<template>
  <div>
    <head>
      <meta charset="utf-8" />
      <title>Property Management</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <meta content="Property Management System" name="description" />
      <meta content="County Revenue System" name="author" />
      <!-- App favicon -->
      <link rel="shortcut icon" href="assets/images/favicon.png">

      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
    </head>

    <body @contextmenu.prevent data-sidebar="dark">
    <NavigationBar/>
    <div id="content" class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">

          <!-- tool bar -->
          <ToolBarValuation/>
          <!-- end of toolbar -->

          <!-- Page Title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Property Management</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);" @click="gotTo('dashboard')">Dashboard</a></li>
                    <li class="breadcrumb-item"><a href="javascript: void(0);" @click="gotTo('valuation-dashboard')">Valuation Roll</a></li>
                    <li class="breadcrumb-item active">Properties</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Summary Cards -->
          <div class="row mb-4">
            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Total Properties</p>
                      <h4 class="mb-0">{{totalProperties.toLocaleString()}}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-primary">
                          <span class="avatar-title">
                            <i class="bx bx-home font-size-24"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Active Properties</p>
                      <h4 class="mb-0">{{activeProperties.toLocaleString()}}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-success">
                          <span class="avatar-title">
                            <i class="bx bx-check-circle font-size-24"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Total Revenue</p>
                      <h4 class="mb-0">{{formatPrice(totalRevenue)}}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-info">
                          <span class="avatar-title">
                            <i class="bx bx-money font-size-24"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Outstanding Arrears</p>
                      <h4 class="mb-0">{{formatPrice(totalArrears)}}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-warning">
                          <span class="avatar-title">
                            <i class="bx bx-error-circle font-size-24"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Main Properties Table -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white">
                  <div class="row align-items-center">
                    <div class="col-md-6">
                      <h4 class="card-title mb-0">Property Records</h4>
                      <p class="text-muted mb-0 mt-1">
                        <i class="bx bx-buildings me-1"></i>
                        Showing {{properties.length}} of {{totalProperties}} properties
                      </p>
                    </div>
                    <div class="col-md-6 text-md-end">
                      <button @click="refreshData" class="btn btn-sm btn-outline-primary me-2" :disabled="loading">
                        <i class="bx bx-refresh" :class="{'bx-spin': loading}"></i> Refresh
                      </button>
                      <button v-if="getRight('ADD PROPERTY')" @click="showAddPropertyModal = true" class="btn btn-sm btn-success me-2">
                        <i class="bx bx-plus"></i> Add Property
                      </button>
                      <button v-if="getRight('DOWNLOAD REPORTS')" @click="downloadReport" class="btn btn-sm btn-primary">
                        <i class="bx bx-download"></i> Export
                      </button>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <!-- Search and Filter Row -->
                  <div class="row mb-4">
                    <div class="col-md-3">
                      <label class="form-label">Search Properties</label>
                      <div class="input-group">
                        <input
                            v-model="searchTerm"
                            class="form-control"
                            type="text"
                            placeholder="LR Number, Owner Name"
                            @keyup.enter="searchProperties"
                        >
                        <button @click="searchProperties" class="btn btn-primary">
                          <i class="bx bx-search"></i>
                        </button>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <label class="form-label">Sub County</label>
                      <select v-model="filterSubCounty" @change="applyFilters" class="form-control">
                        <option value="">All Sub Counties</option>
                        <option v-for="county in subCounties" :key="county" :value="county">{{county}}</option>
                      </select>
                    </div>
                    <div class="col-md-2">
                      <label class="form-label">Ward</label>
                      <select v-model="filterWard" @change="applyFilters" class="form-control">
                        <option value="">All Wards</option>
                        <option v-for="ward in wards" :key="ward" :value="ward">{{ward}}</option>
                      </select>
                    </div>
                    <div class="col-md-2">
                      <label class="form-label">Status</label>
                      <select v-model="filterStatus" @change="applyFilters" class="form-control">
                        <option value="">All Status</option>
                        <option value="Active">Active</option>
                        <option value="Suspended">Suspended</option>
                        <option value="Rate Struck">Rate Struck</option>
                      </select>
                    </div>
                    <div class="col-md-3">
                      <label class="form-label">Records per page</label>
                      <div class="d-flex">
                        <select v-model="perPage" @change="applyFilters" class="form-control me-2">
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                          <option value="500">500</option>
                        </select>
                        <button @click="clearFilters" class="btn btn-outline-secondary">
                          <i class="bx bx-x"></i> Clear
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Properties Table -->
                  <div class="table-responsive">
                    <table class="table table-hover align-middle mb-0" v-if="!loading && properties.length > 0">
                      <thead class="table-dark">
                      <tr>
                        <th style="width: 5%">#</th>
                        <th style="width: 15%">LR Number</th>
                        <th style="width: 20%">Owner Name</th>
                        <th style="width: 15%">Location</th>
                        <th style="width: 10%">Sub County</th>
                        <th style="width: 10%">Size (Ha)</th>
                        <th class="text-end" style="width: 10%">Annual Charges</th>
                        <th class="text-end" style="width: 10%">Arrears</th>
                        <th class="text-center" style="width: 5%">Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(property, index) in paginatedProperties" :key="property.id">
                        <td>{{(currentPage - 1) * perPage + index + 1}}</td>
                        <td>
                          <div class="d-flex align-items-center">
                            <div class="avatar-xs me-2">
                                  <span class="avatar-title rounded-circle bg-soft-primary text-primary">
                                    <i class="bx bx-home"></i>
                                  </span>
                            </div>
                            <div>
                              <h6 class="mb-0">{{property.LRNumber}}</h6>
                              <small class="text-muted">{{property.UPN || 'No UPN'}}</small>
                            </div>
                          </div>
                        </td>
                        <td>
                          <h6 class="mb-0">{{property.ownerNames}}</h6>
                          <small class="text-muted">{{property.ownerPhoneNo || 'No phone'}}</small>
                        </td>
                        <td>
                          <span>{{property.percelAddress || 'Not specified'}}</span><br>
                          <small class="text-muted">{{property.wardName}}</small>
                        </td>
                        <td>
                          <span class="badge bg-soft-info text-info">{{property.subCountyName}}</span>
                        </td>
                        <td class="text-center">
                          <strong>{{property.percelSize}}</strong>
                        </td>
                        <td class="text-end">
                          <strong class="text-primary">{{formatPrice(property.annualCharges)}}</strong>
                        </td>
                        <td class="text-end">
                          <strong :class="property.outstandingArrears > 0 ? 'text-danger' : 'text-success'">
                            {{formatPrice(property.outstandingArrears)}}
                          </strong>
                        </td>
                        <td class="text-center">
                          <div class="dropdown">
                            <button class="btn btn-sm btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown">
                              <i class="bx bx-dots-vertical-rounded"></i>
                            </button>
                            <ul class="dropdown-menu">
                              <li><a class="dropdown-item" @click="viewPropertyDetails(property)"><i class="bx bx-eye me-2"></i>View Details</a></li>
                              <li><a class="dropdown-item" @click="viewPropertyHistory(property)"><i class="bx bx-history me-2"></i>View History</a></li>
                              <li><hr class="dropdown-divider"></li>
                              <li><a class="dropdown-item" @click="createUpdateRequest(property)"><i class="bx bx-edit-alt me-2"></i>Create Update Request</a></li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>

                    <!-- Loading State -->
                    <div v-if="loading" class="text-center py-5">
                      <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                      <p class="mt-3 mb-0">Loading properties...</p>
                    </div>

                    <!-- Empty State -->
                    <div v-if="!loading && properties.length === 0" class="text-center py-5">
                      <img :src="'./assets/images/no-results.png'" alt="No results" style="width: 150px; opacity: 0.5;">
                      <h5 class="mt-3">No Properties Found</h5>
                      <p class="text-muted">No properties match your search criteria.</p>
                      <button @click="clearFilters" class="btn btn-primary">Clear Filters</button>
                    </div>
                  </div>

                  <!-- Pagination -->
                  <div class="row mt-4" v-if="!loading && properties.length > 0">
                    <div class="col-md-6">
                      <p class="text-muted">
                        Showing {{(currentPage - 1) * perPage + 1}} to {{Math.min(currentPage * perPage, totalProperties)}} of {{totalProperties}} properties
                      </p>
                    </div>
                    <div class="col-md-6">
                      <nav>
                        <ul class="pagination justify-content-end mb-0">
                          <li class="page-item" :class="{disabled: currentPage === 1}">
                            <a class="page-link" @click="changePage(currentPage - 1)" href="javascript:void(0)">Previous</a>
                          </li>
                          <li
                              v-for="page in visiblePages"
                              :key="page"
                              class="page-item"
                              :class="{active: page === currentPage}"
                          >
                            <a class="page-link" @click="changePage(page)" href="javascript:void(0)">{{page}}</a>
                          </li>
                          <li class="page-item" :class="{disabled: currentPage === totalPages}">
                            <a class="page-link" @click="changePage(currentPage + 1)" href="javascript:void(0)">Next</a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <!-- Modal Components -->
          <RequestDetailsModal
              :show="showDetailsModal"
              :request="selectedPropertyAsRequest"
              @close="closeDetailsModal"
          />

          <RequestHistoryModal
              :show="showHistoryModal"
              :request="selectedPropertyAsRequest"
              @close="closeHistoryModal"
          />

        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">
              ©{{new Date().getFullYear()}} County Revenue System
            </div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                Property Management System
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import router from "@/router";
import {paysol, biller, execute, execute2, executeDownload, getRight, landRate} from "@/api";
import moment from 'moment';
import ToolBarValuation from "@/components/valuation/ToolBar.vue";
import RequestDetailsModal from "@/components/valuation/RequestDetailsModal.vue";
import RequestHistoryModal from "@/components/valuation/RequestHistoryModal.vue";

export default {
  name: "ValuationProperties",
  components: {
    ToolBarValuation,
    NavigationBar,
    RequestDetailsModal,
    RequestHistoryModal
  },

  data() {
    return {
      loading: false,

      // Search and filters
      searchTerm: '',
      filterSubCounty: '',
      filterWard: '',
      filterStatus: '',
      perPage: 50,
      currentPage: 1,

      // Data
      properties: [],
      subCounties: [],
      wards: [],

      // Statistics
      totalProperties: 0,
      activeProperties: 0,
      totalRevenue: 0,
      totalArrears: 0,

      // Modals
      showAddPropertyModal: false,
      selectedProperty: null,
      showDetailsModal: false,
      showHistoryModal: false
    }
  },

  computed: {
    filteredProperties() {
      let filtered = [...this.properties];

      if (this.searchTerm) {
        const term = this.searchTerm.toLowerCase();
        filtered = filtered.filter(property =>
            property.LRNumber?.toLowerCase().includes(term) ||
            property.ownerNames?.toLowerCase().includes(term) ||
            property.percelAddress?.toLowerCase().includes(term)
        );
      }

      if (this.filterSubCounty) {
        filtered = filtered.filter(property => property.subCountyName === this.filterSubCounty);
      }

      if (this.filterWard) {
        filtered = filtered.filter(property => property.wardName === this.filterWard);
      }

      if (this.filterStatus) {
        filtered = filtered.filter(property => property.status === this.filterStatus);
      }

      return filtered;
    },

    paginatedProperties() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + parseInt(this.perPage);
      return this.filteredProperties.slice(start, end);
    },

    totalPages() {
      return Math.ceil(this.filteredProperties.length / this.perPage);
    },

    visiblePages() {
      const pages = [];
      const total = this.totalPages;
      const current = this.currentPage;

      if (total <= 7) {
        for (let i = 1; i <= total; i++) {
          pages.push(i);
        }
      } else {
        if (current <= 4) {
          for (let i = 1; i <= 5; i++) {
            pages.push(i);
          }
          pages.push('...');
          pages.push(total);
        } else if (current >= total - 3) {
          pages.push(1);
          pages.push('...');
          for (let i = total - 4; i <= total; i++) {
            pages.push(i);
          }
        } else {
          pages.push(1);
          pages.push('...');
          for (let i = current - 1; i <= current + 1; i++) {
            pages.push(i);
          }
          pages.push('...');
          pages.push(total);
        }
      }

      return pages;
    },

    selectedPropertyAsRequest() {
      if (!this.selectedProperty) return null;

      // Transform property object to look like a request object for the modals
      return {
        id: this.selectedProperty.id,
        referenceNumber: this.selectedProperty.LRNumber,
        reference_number: this.selectedProperty.LRNumber,
        LRNumber: this.selectedProperty.LRNumber,
        ownerNames: this.selectedProperty.ownerNames,
        status: 'property-view', // Special status to indicate this is property view
        submitted_date: this.selectedProperty.created_at || new Date().toISOString(),
        processed_date: this.selectedProperty.updated_at,
        processed_by: 'System',
        processed_by_id_no: 'AUTO',
        update_type: 'Property Details View',
        current_data: JSON.stringify({
          ownerNames: this.selectedProperty.ownerNames,
          ownerPhoneNo: this.selectedProperty.ownerPhoneNo,
          ownerEmail: this.selectedProperty.ownerEmail,
          ownerID: this.selectedProperty.ownerID,
          physicalAddress: this.selectedProperty.physicalAddress,
          percelAddress: this.selectedProperty.percelAddress,
          useName: this.selectedProperty.useName,
          percelSize: this.selectedProperty.percelSize,
          annualCharges: this.selectedProperty.annualCharges,
          outstandingArrears: this.selectedProperty.outstandingArrears,
          subCountyName: this.selectedProperty.subCountyName,
          wardName: this.selectedProperty.wardName,
          status: this.selectedProperty.status
        }),
        requested_data: JSON.stringify({}), // Empty for property view
        requester_info: JSON.stringify({
          fullName: this.selectedProperty.ownerNames,
          idNumber: this.selectedProperty.ownerID || 'N/A',
          phoneNumber: this.selectedProperty.ownerPhoneNo || 'N/A',
          email: this.selectedProperty.ownerEmail || 'N/A',
          relationship: 'owner',
          authorizationDetails: 'Property Owner'
        }),
        notes: `Property details view for ${this.selectedProperty.LRNumber}`
      };
    }
  },

  mounted() {
    this.getProperties();
    this.getFilterOptions();
    this.menuAccess();

    // Check if there's a search term from dashboard
    const searchTerm = sessionStorage.getItem('propertySearchTerm');
    if (searchTerm) {
      this.searchTerm = searchTerm;
      sessionStorage.removeItem('propertySearchTerm');
      this.searchProperties();
    }
  },

  methods: {
    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Property Management");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller)
          .then(() => {})
          .catch(() => {});
    },

    getRight(type) {
      return getRight(type);
    },

    getProperties() {
      this.loading = true;

      const data = new FormData();
      data.append("function", "getAllProperties");
      data.append("page", this.currentPage);
      data.append("perPage", this.perPage);

      execute2(data, landRate)
          .then((res) => {
            if (res.data.success) {
              const responseData = res.data.data;
              this.properties = responseData.properties || [];
              this.totalProperties = responseData.total || 0;
              this.activeProperties = responseData.activeProperties || 0;
              this.totalRevenue = responseData.totalRevenue || 0;
              this.totalArrears = responseData.totalArrears || 0;
            } else {
              alert(res.data.message);
            }
          })
          .catch((e) => {
            console.error('Error loading properties:', e);
            alert('Failed to load properties. Please try again.');
          })
          .finally(() => {
            this.loading = false;
          });
    },

    getFilterOptions() {
      const data = new FormData();
      data.append("function", "getPropertyFilterOptions");

      execute2(data, landRate)
          .then((res) => {
            if (res.data.success) {
              this.subCounties = res.data.data.subCounties || [];
              this.wards = res.data.data.wards || [];
            }
          })
          .catch((e) => {
            console.error('Error loading filter options:', e);
          });
    },

    searchProperties() {
      this.currentPage = 1;
      this.applyFilters();
    },

    applyFilters() {
      this.currentPage = 1;
      // The computed properties will handle the filtering
    },

    clearFilters() {
      this.searchTerm = '';
      this.filterSubCounty = '';
      this.filterWard = '';
      this.filterStatus = '';
      this.currentPage = 1;
    },

    changePage(page) {
      if (page >= 1 && page <= this.totalPages && page !== '...') {
        this.currentPage = page;
      }
    },

    refreshData() {
      this.getProperties();
    },

    // Updated method to use RequestDetailsModal
    viewPropertyDetails(property) {
      this.selectedProperty = property;
      this.showDetailsModal = true;
    },

    // New method to use RequestHistoryModal
    viewPropertyHistory(property) {
      this.selectedProperty = property;
      this.showHistoryModal = true;
    },

    // Modal close methods
    closeDetailsModal() {
      this.showDetailsModal = false;
      this.selectedProperty = null;
    },

    closeHistoryModal() {
      this.showHistoryModal = false;
      this.selectedProperty = null;
    },

    // Keep existing methods for backward compatibility
    viewProperty(property) {
      this.viewPropertyDetails(property);
    },

    viewHistory(property) {
      this.viewPropertyHistory(property);
    },

    editProperty(property) {
      // Open edit modal or navigate to edit page
      this.selectedProperty = property;
      // Navigate to edit page or show edit modal
      sessionStorage.setItem('editProperty', JSON.stringify(property));
      this.gotTo('valuation-property-edit');
    },

    createUpdateRequest(property) {
      // Navigate to create update request for this property
      sessionStorage.setItem('walkInProperty', JSON.stringify(property));
      this.gotTo('valuation-walk-in');
    },

    downloadReport() {
      // Prepare data for download
      const headers = ['LR Number', 'Owner Name', 'Location', 'Sub County', 'Ward', 'Size (Ha)', 'Annual Charges', 'Outstanding Arrears', 'Status'];
      const rows = [headers.join(',')];

      this.filteredProperties.forEach((property) => {
        const row = [
          `"${property.LRNumber}"`,
          `"${property.ownerNames}"`,
          `"${property.percelAddress || ''}"`,
          `"${property.subCountyName}"`,
          `"${property.wardName}"`,
          property.percelSize,
          property.annualCharges,
          property.outstandingArrears,
          property.status
        ];
        rows.push(row.join(','));
      });

      // Add summary
      rows.push('');
      rows.push('Summary Information');
      rows.push(`Total Properties:,${this.filteredProperties.length}`);
      rows.push(`Active Properties:,${this.filteredProperties.filter(p => p.status === 'Active').length}`);
      rows.push(`Total Annual Charges:,${this.filteredProperties.reduce((sum, p) => sum + parseFloat(p.annualCharges || 0), 0)}`);
      rows.push(`Total Outstanding Arrears:,${this.filteredProperties.reduce((sum, p) => sum + parseFloat(p.outstandingArrears || 0), 0)}`);

      // Create and download CSV
      const csvContent = rows.join('\n');
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `properties_export_${moment().format('YYYY-MM-DD')}.csv`;
      link.click();
    },

    formatPrice(value) {
      const formatter = new Intl.NumberFormat('en-KE', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
      return formatter.format(value || 0);
    },

    gotTo(route) {
      router.push(route);
    }
  }
}
</script>

<style scoped>
.bx-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.bg-soft-primary {
  background-color: rgba(50, 149, 239, 0.1);
}

.bg-soft-success {
  background-color: rgba(52, 195, 143, 0.1);
}

.bg-soft-info {
  background-color: rgba(80, 165, 241, 0.1);
}

.bg-soft-warning {
  background-color: rgba(244, 206, 109, 0.1);
}

.bg-soft-danger {
  background-color: rgba(244, 106, 106, 0.1);
}

.mini-stats-wid:hover {
  transform: translateY(-2px);
  transition: all 0.3s ease;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.pagination .page-link {
  cursor: pointer;
}

.dropdown-toggle::after {
  display: none;
}

.table td {
  vertical-align: middle;
}
</style>